import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import type { ExtractGetRoutes, RouteSegment } from '@openclassrooms/sdk';
import checkGetRetry from '../services/checkGetRetry';
import get from '../services/get';
import type { ApiRoutes, GetRequestBuilder, RequestOption } from '../types';
import useQueryKeys from './useQueryKeys';
export default function useSuspenseGet(path, options) {
  const $ = _c(21);
  let t0;
  if ($[0] !== options) {
    t0 = options || {};
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let customQueryKey;
  let otherOptions;
  let t1;
  if ($[2] !== t0) {
    ({
      watchedQueryKeys: t1,
      queryKey: customQueryKey,
      ...otherOptions
    } = t0);
    $[2] = t0;
    $[3] = customQueryKey;
    $[4] = otherOptions;
    $[5] = t1;
  } else {
    customQueryKey = $[3];
    otherOptions = $[4];
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const watchedQueryKeys = t2;
  let t3;
  if ($[8] !== otherOptions) {
    t3 = {
      ...otherOptions,
      enabled: 1
    };
    $[8] = otherOptions;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== customQueryKey || $[11] !== path || $[12] !== t3 || $[13] !== watchedQueryKeys) {
    t4 = {
      path,
      customQueryKey,
      options: t3,
      watchedQueryKeys
    };
    $[10] = customQueryKey;
    $[11] = path;
    $[12] = t3;
    $[13] = watchedQueryKeys;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const queryKey = useQueryKeys(t4);
  let t5;
  if ($[15] !== otherOptions || $[16] !== path) {
    t5 = () => get(path, otherOptions as any);
    $[15] = otherOptions;
    $[16] = path;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== queryKey || $[19] !== t5) {
    t6 = {
      queryKey,
      queryFn: t5,
      staleTime: 5000,
      retry: checkGetRetry
    };
    $[18] = queryKey;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return useSuspenseQuery(t6);
}